// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"buttonWrapper--2JqXs","uploadInput":"uploadInput--3IApc"};